import { render, staticRenderFns } from "./main.vue?vue&type=template&id=9fde2e8e"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fde2e8e')) {
      api.createRecord('9fde2e8e', component.options)
    } else {
      api.reload('9fde2e8e', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=9fde2e8e", function () {
      api.rerender('9fde2e8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/merchandiseSelect/main.vue"
export default component.exports